module.exports = __webpack_public_path__ + "static/illustration-d1312d11890c3124b56fd86467933365.svg";